<div class="card card-nb h-100 w-100">
  <div class="card-body p-4 w-100">
    <h2 class="mb-2">{{ "subscription_invoice_type_headline" | i18next }}</h2>
    <div class="d-flex flex-column">
      <div class="mb-3" [innerHTML]="'subscription_invoice_type_description' | i18next: {type: invoiceDocFormat | i18next } "></div>
      @if (canEdit) {
        <div class="mb-3">
          <i class="fa fa-info-circle red mr-2"></i>
          <span class="subinformations">{{ "subscription_invoice_type_info" | i18next: {possibleTypes: invoiceFormatForTranslation} }}</span>
        </div>
      }
      @if (!isEdit && canEdit) {
        <div class="d-flex mt-auto w-100 justify-content-end mt-3">
          <button
            name="subscription-invoice-format-edit"
            class="btn btn-outline-primary"
            (click)="edit()">
            {{'subscription_invoice_type_edit_button'|i18next}}
          </button>
        </div>
      }
      @if (isEdit) {
        <div>
          @if (selectableTypes && selectableTypes.length > 0) {
            <p-select
              class="w-100"
              [options]="selectableTypes"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="selectedFormat"
            ></p-select>
          }
          <div class="d-flex mt-auto w-100 justify-content-end mt-3">
            <button name="subscription-invoice-format-cancel" class="btn btn-link"
              (click)="cancel()">
              {{'app_cancel'|i18next}}
            </button>
            <button name="subscription-invoice-format-save" class="btn btn-outline-primary"
              (click)="save()">
              {{'app_save'|i18next}}
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
